/**
 * @typedef {Object} Card
 * @property {String} id
 * @property {String} brand
 * @property {String} country
 * @property {String} last4
 * @property {String} funding
 * @property {Number} expmonth
 * @property {Number} expyear
 * @property {Object} metadata
 * @property {Date} createdAt
 */

/**
 * @typedef {Object} AccountObject
 * @property {Array<Card>} cards
 * @property {String} defaultcard
 * @property {String} customerid
 */

/**
 * @typedef {Object} PaymentMethods
 * @property {Array<Card>} cards
 * @property {String} defaultcard
 */

/**
 * @typedef {Object} PaymentResponse
 * @property {PaymentMethods} paymentMethods
 */

const path = `/v2/organization/billing/paymentmethods`;
/**
 * @param {Object} param0
 * @param {import("axios").AxiosInstance} param0.repository
 */
export default function actions({ repository } = {}) {
  /**
   * @returns {PaymentResponse}
   */
  async function get() {
    const response = await repository.get(path);
    return response.data && response.data ? response.data : {};
  }
  async function create({ paymentmethod } = {}) {
    const response = await repository.post(path, {
      paymentmethod: paymentmethod
    });
    return response.data && response.data.paymentMethods
      ? response.data.paymentMethods
      : {};
  }
  return Object.freeze({
    get,
    create
  });
}
